<div class="page-ingestion-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon>auto_stories</mat-icon>
      Page Ingestion
    </h2>
  </div>

  <mat-dialog-content>
    <!-- File Information -->
    <div class="file-info-section">
      <div class="selected-file-display">
        <mat-icon class="file-icon">description</mat-icon>
        <div class="file-details">
          <div class="file-name">{{ data.file.getFileName() }}</div>
          <div class="file-metadata">
            <span class="document-type">{{ getDocumentTypeDisplay() }}</span>
            <span class="separator">•</span>
            <span class="file-size">{{ formatFileSize(data.file.getFileSizeBytes()) }}</span>
            <span class="separator">•</span>
            <span class="page-status">{{ getIngestedPagesText() }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Ingestion Configuration -->
    <div class="ingestion-config">
      <!-- Page Selection -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Pages to Process</mat-label>
        <mat-select [(ngModel)]="pages">
          <mat-option value="all">All pages ({{ getRemainingPagesText() }})</mat-option>
          <mat-option value="custom">Custom Page Selection</mat-option>
        </mat-select>
        <mat-hint>Select which pages from the PDF to process</mat-hint>
      </mat-form-field>

      <!-- Custom Pages Input -->
      @if (pages === 'custom') {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Page Numbers</mat-label>
          <input
            matInput
            [(ngModel)]="customPages"
            placeholder="e.g., 1,3,5-10,15"
            [class.error]="!isCustomPagesValid()"
          />
          @if (isCustomPagesValid()) {
            <mat-hint> Enter page numbers separated by commas (ranges like 5-10 supported) </mat-hint>
          }
          @if (!isCustomPagesValid()) {
            <mat-error> Please enter valid page numbers (1-{{ data.file.getPageCount() }}) </mat-error>
          }
        </mat-form-field>
      }

      <!-- Information about async processing -->
      <div class="info-section">
        <div
          class="info-expandable"
          (click)="toggleInfoExpanded()"
          (keydown.enter)="toggleInfoExpanded()"
          (keydown.space)="toggleInfoExpanded(); $event.preventDefault()"
          tabindex="0"
          role="button"
          [attr.aria-expanded]="infoExpanded"
        >
          <mat-icon class="expand-icon" [class.expanded]="infoExpanded">
            {{ infoExpanded ? 'expand_less' : 'expand_more' }}
          </mat-icon>
          <span class="info-text">What happens during async ingestion?</span>
        </div>

        @if (infoExpanded) {
          <div class="info-content">
            <p>Page ingestion runs asynchronously in the background with the following steps:</p>
            <ul>
              <li>Tasks are created for each page to enable parallel processing</li>
              <li>PDF pages are extracted and processed asynchronously</li>
              <li>Text content is analyzed using AI</li>
              <li>Architectural elements and compliance information are identified</li>
              <li>Real-time progress updates are provided via live notifications</li>
              <li>Pages become available for review and analysis upon completion</li>
            </ul>
            <p>You can monitor progress and continue using the application while ingestion runs.</p>
          </div>
        }
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="!canStartIngestion()" (click)="onStartIngestion()">
      <mat-icon>play_arrow</mat-icon>
      Start Page Ingestion
    </button>
  </mat-dialog-actions>
</div>
